
import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";

import {
  CLEAR_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_STATE,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_FAILED,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_PROGRESS,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_SUCCESSS,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_FAILED,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_PROGRESS,
  FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_SUCCESS,
} from "./habitationalPolicyChangeReqActions";
import { initialHabitationalPolicyChangeReqState } from "./habitationalPolicyChangeReq.types";
import { HabitationalPolicyChangeReqActions } from ".";

export const HabitationalPolicyChangeReqReducer = (
  state: IStoreState["habitational"]["policyChangeReq"] = initialHabitationalPolicyChangeReqState,
  action: HabitationalPolicyChangeReqActions
) => {
  switch (action.type) {
    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }

    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.error = null;
        draftState.policyChangeData = initialHabitationalPolicyChangeReqState["policyChangeData"];
      });
      return newState;
    }
    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_SUCCESSS: {
      const { data } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.policyChangeData = data;
      });
      return newState;
    }
    case FETCH_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_FAILED: {
      const { error } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.error = error || null;
        draftState.policyChangeData = initialHabitationalPolicyChangeReqState["policyChangeData"];
      });
      return newState;
    }

    case CLEAR_HABITATIONAL_POLICY_CHANGE_REQ_APPLICATION_STATE: {
      return initialHabitationalPolicyChangeReqState;
    }

    default: {
      return state;
    }
  }
};
